export default __webpack_public_path__ + "static/media/Inter-SemiBold.40ff2d91.woff";